<template>
    <div v-if="categoryExits"
        class="py-3 px-2 w-full flex"
        :class="[{'bg-red text-white': categoryId === categoryActive, 'hover:text-red': categoryId !== categoryActive && categoryAvailable, 'text-light-gray': !categoryAvailable } ]"
        @click="toggle">
        <div>
            <icon v-if="categoryId === categoryActive"
                  class="flex-shrink-0 w-4 h-4 fill-current p-1 mr-2 mt-1"
                  name="close" />
        </div>
        <div>{{ name }}</div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import Icon from '../base/Icon.vue';

@Component({
    components: { Icon }
})
export default class Category extends Vue {
    @Inject({
        default: () => null
    }) readonly registerCategory!: Function;

    @Prop({ required: true }) name: string;
    @Prop({ required: true }) categoryId: string;
    @Prop({ required: true }) categoryKey: string;
    @Prop({ required: true }) categoryActive: string;

    categoryAvailable = true;
    categoryExits = true;
    checked = false;

    mounted() {
        this.registerCategory(this);
    }

    toggle() {
        if (this.categoryAvailable) {
            this.checked = !this.checked;
            this.$emit('toggle', { id: this.categoryId, name: this.name, key: this.categoryKey, checked: this.checked });
        }
    }
}
</script>
